import React, { useState, useRef, useEffect, useContext } from 'react';
import classnames from 'classnames';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';
import * as IntentSelectorConstants from './constants';
import { Intent } from './types';
import IntentItem from './intentItem';
import { IntentSelectorProps } from '.';

export interface IntentListProps {
  clickableType: IntentSelectorConstants.CLICKABLE_TYPE;
  intentList: Intent[];
  handleIntentClick: (index: number) => void;
  useUIOptimisationRecommender?: IntentSelectorProps['useUIOptimisationRecommender'];
}

export default (props: IntentListProps) => {
  const { intentList, clickableType, handleIntentClick, useUIOptimisationRecommender } = props;
  const intentsRef = useRef<Array<HTMLDivElement | null>>([]);

  const [itemClickable, setItemClickable] = useState<boolean[]>(
    new Array(intentList.length).fill(clickableType !== IntentSelectorConstants.CLICKABLE_TYPE.ALL_DISABLED)
  );

  const onIntentClick = (index: number) => {
    if (!useUIOptimisationRecommender) {
      if (clickableType === IntentSelectorConstants.CLICKABLE_TYPE.CLICKED_ONCE_TO_DISABLED) {
        setItemClickable(itemClickable.map((_) => false));
      } else if (clickableType === IntentSelectorConstants.CLICKABLE_TYPE.CLICKED_ITEM_TO_DISABLED) {
        const copiedItemClickable = [...itemClickable];
        copiedItemClickable[index] = false;
        setItemClickable(copiedItemClickable);
      }
    }

    handleIntentClick(index);
  };

  useEffect(() => {
    addObserver(intentsRef.current);

    return () => {
      removeObserver(intentsRef.current);
    };
  }, []);

  return (
    <div className={classnames('intent-list')}>
      {intentList?.map((item, index) => (
        <IntentItem
          item={item}
          index={index}
          disabled={!itemClickable[index]}
          onIntentClick={onIntentClick}
          ref={intentsRef}
          key={item.id}
          useUIOptimisationRecommender={useUIOptimisationRecommender}
        />
      ))}
    </div>
  );
};
